import {
  removeUrlProtocolParts,
  getRequestLanguages,
  getResourceSearchFullText,
} from 'utils';
import { resourceItemAdapter } from './adapters';

const mapPlatformName = {
  telegramchannels: 'telegram',
  newsagencies: 'news',
  newspaperagencies: 'newspaper',
  instagramusers: 'instagram',
  twitterusers: 'twitter',
  virastyusers: 'virasty',
  'iranian-platforms-channels': 'nativePlatforms',
};
const mapReversePlatformName = {
  telegram: 'telegramchannels',
  news: 'newsagencies',
  newspaper: 'newspaperagencies',
  instagram: 'instagramusers',
  twitter: 'twitterusers',
  virasty: 'virastyusers',
  nativePlatforms: 'iranian-platforms-channels',
};

export const transformFetchBlackListResponse = (response) => {
  const transformedResult = [];
  if (response || response?.length > 0) {
    transformedResult['platforms'] = response?.platforms;
  }
  return transformedResult;
};

export const transformFetchBlackListResourcesResponse = (
  response,
  platform = undefined
) => {
  const _platform = mapPlatformName[platform] ?? undefined;

  let transformedResult = [];

  if (response?.data?.result?.data?.length > 0 && _platform) {
    transformedResult = response?.data?.result?.data?.map((item) =>
      resourceItemAdapter(item, _platform)
    );
  } else if (response?.data?.result?.data) {
    Object.entries(response?.data?.result?.data)?.map(([key, value]) => {
      value?.forEach((item) => {
        transformedResult.push(resourceItemAdapter(item, mapPlatformName[key]));
      });
    });
  }

  return {
    data: transformedResult,
    total: response?.data?.result?.meta?.total,
  };
};

export const transformSearchResourcesResponse = (response, platform) => {
  let transformedResult = [];

  if (response?.data?.result?.data?.length > 0 && platform) {
    transformedResult = response?.data?.result?.data?.map((item) =>
      resourceItemAdapter(item, platform)
    );
  }

  return {
    data: transformedResult,
    total: response?.data?.result?.meta?.total,
  };
};

export const prepareBlackListResourcesForSave = (
  method,
  addedResources,
  title,
  description
) => {
  const deleteParams = {
    telegramchannels: [],
    newsagencies: [],
    newspaperagencies: [],
    instagramusers: [],
    twitterusers: [],
    virastyusers: [],
    'iranian-platforms-channels': [],
  };

  const addParams = {
    telegramchannels: [],
    newsagencies: [],
    newspaperagencies: [],
    instagramusers: [],
    twitterusers: [],
    virastyusers: [],
    'iranian-platforms-channels': [],
  };

  const params = {
    delete_resources: [],
    add_resources: [],
    resources: [],
    name: title,
    description,
  };

  if (method === 'put') {
    Object.entries(deleteParams).map(([key, value]) => {
      if (value?.length > 0) {
        params.delete_resources.push({
          platform: key,
          ids: value,
        });
      }
    });
  }

  if (addedResources?.length > 0) {
    addedResources?.map((resource) => {
      addParams[mapReversePlatformName[resource?.platform]].push(resource?.id);
    });
  }

  Object.entries(addParams).map(([key, value]) => {
    if (value?.length > 0) {
      params[method === 'put' ? 'add_resources' : 'resources'].push({
        platform: key,
        ids: value,
      });
    }
  });

  if (method === 'put') {
    delete params.resources;
  } else {
    delete params.delete_resources;
    delete params.add_resources;
  }

  return params;
};

export const prepareSearchResourcesRequest = (
  blackListReducer,
  settingsReducer,
  params
) => {
  const platform = blackListReducer?.selectedPlatformForResources;

  const filter = blackListReducer?.filters[platform];

  const _defaulParams = {
    news: {
      api_path: '/news/agencies',
    },
    newspaper: { api_path: '/newspaper/agencies' },
    nativePlatforms: {
      api_path: '/iranian-platforms/channels',
      sort: 'member_count',
      sort_type: 'desc',
    },
    instagram: {
      api_path: '/instagram/users',
      sort: 'follower_count',
      sort_type: 'desc',
    },
    twitter: {
      api_path: '/twitter/users',
      sort: 'follower_count',
      sort_type: 'desc',
    },
    telegram: {
      api_path: '/telegram/channels',
      sort: 'member_count',
      sort_type: 'desc',
    },
  };

  return {
    ..._defaulParams[platform],
    q: removeUrlProtocolParts(params.query) || undefined,
    time_duration: undefined,

    media_types: filter?.resourceTypeFilter?.isDisabled
      ? undefined
      : filter?.resourceTypeFilter?.selectedIds,
    content_tag_ids: filter?.contentTagFilter?.selectedIds,
    m3_age: filter?.ageFilter?.isDisabled
      ? undefined
      : filter?.ageFilter?.selectedIds,
    sort: filter?.sortResourcesBy?.selected,
    sort_type: filter?.sortResourcesBy?.order,
    gender: filter?.genderFilter?.isDisabled
      ? undefined
      : filter?.genderFilter?.selectedIds,
    min_media:
      filter?.contentBasedFilter?.selectedObjects?.content_count?.active &&
      filter?.contentBasedFilter?.selectedObjects?.content_count?.min !== null
        ? filter?.contentBasedFilter?.selectedObjects?.content_count?.min
        : undefined,
    max_media:
      filter?.contentBasedFilter?.selectedObjects?.content_count?.active &&
      filter?.contentBasedFilter?.selectedObjects?.content_count?.max !== null
        ? filter?.contentBasedFilter?.selectedObjects?.content_count?.max
        : undefined,
    min_follower:
      filter?.contentBasedFilter?.selectedObjects?.follower_count?.active &&
      filter?.contentBasedFilter?.selectedObjects?.follower_count?.min !== null
        ? filter?.contentBasedFilter?.selectedObjects?.follower_count?.min
        : undefined,
    max_follower:
      filter?.contentBasedFilter?.selectedObjects?.follower_count?.active &&
      filter?.contentBasedFilter?.selectedObjects?.follower_count?.max !== null
        ? filter?.contentBasedFilter?.selectedObjects?.follower_count?.max
        : undefined,
    influence_categories: filter?.contentBasedFilter?.selectedObjects
      ?.influenceRate?.active
      ? filter?.contentBasedFilter?.selectedObjects?.influenceRate.selectedIds
      : undefined,
    min_member:
      filter?.contentBasedFilter?.selectedObjects?.member_count?.active &&
      filter?.contentBasedFilter?.selectedObjects?.member_count?.min !== null
        ? filter?.contentBasedFilter?.selectedObjects?.member_count?.min
        : undefined,
    max_member:
      filter?.contentBasedFilter?.selectedObjects?.member_count?.active &&
      filter?.contentBasedFilter?.selectedObjects?.member_count?.max !== null
        ? filter?.contentBasedFilter?.selectedObjects?.member_count?.max
        : undefined,
    langs: filter?.languageFilter?.isDisabled
      ? undefined
      : getRequestLanguages({ languageFilter: filter?.languageFilter }),

    page: params?.page ?? blackListReducer?.searchResources?.page,
    count:
      params?.count ??
      settingsReducer?.filters?.public?.pageContentCountSlider?.selectedValue,
    full_text: getResourceSearchFullText(params.query),
  };
};
